// Brand assets (2026-10-18) — the ONE place third-party brand files are configured.
//
// GARMIN: no official Garmin asset is in the repository yet, so `approved` is false and every Garmin surface renders
// the neutral, text-only <GarminLogo /> fallback (the word "Garmin" — never a drawn or recreated Garmin mark).
// To switch on the official logo:
//   1. obtain the official asset and written permission to use it (Garmin's brand / developer guidelines; RitmoIQ
//      connects through Stridee, so check whether Stridee's agreement covers RitmoIQ or a direct approval is needed);
//   2. add the unmodified files under public/brand/ (a light and a dark variant if the guidelines provide them);
//   3. set the paths below and `approved: true`, and the attribution text the guidelines require.
// Never imply an official Garmin partnership or certification unless that is authorised.
export const GARMIN_BRAND = {
  approved: false,
  light: null,        // e.g. '/brand/garmin-logo-light.svg' (for light backgrounds)
  dark: null,         // e.g. '/brand/garmin-logo-dark.svg'  (for dark backgrounds)
  attribution: null,  // e.g. the trademark notice required by the guidelines
};
